import { useShopwareContext } from "#imports";

async function useCrossSellings() {
  const { apiInstance } = useShopwareContext();
  const { product } = useProduct();

  const hasCrossSellingProducts = computed(() => {
    return product.value?.crossSellings?.find((crossSelling) => crossSelling.active === true);
  });

  const crossSellingProducts = ref([]);

  const loadCrossSellingProducts = async () => {
    if (hasCrossSellingProducts.value) {
      const { data } = await apiInstance.invoke.post(
        `/store-api/product/${product.value.id}/cross-selling`,
      );

      crossSellingProducts.value =
        data?.map((group) => ({
          name: group.crossSelling.name,
          products: group.products,
        })) || [];
    }
  };

  return {
    hasCrossSellingProducts,
    loadCrossSellingProducts,
    crossSellingProducts,
  };
}

export const useCrossSelling = createSharedComposable(useCrossSellings);
